import { defineStore } from 'pinia';
import { useState } from '@/composables/common/useState';
import { CurrentUser } from '@/types/user/user.entity';
import { computed, ref } from 'vue';
import AuthenticationService from '@/services/coda-qa-user/authentication.service';
import { Authentication } from '@/modules/authentication/Authentication';
import { CfsPermissions } from '@/types/coda-qa-user/permissions.types';
import { useOrganizationStore } from '@/store/modules/useOrganizationStore';

export const useUserStore = defineStore('USER', () => {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const isAuthenticated = ref(false);

  const currentUserName = computed(() => {
    if (!currentUser.value) {
      return '';
    }
    const { contact } = currentUser.value;
    return `${contact.firstName} ${contact.lastName}`;
  });

  const currentUserAvailableProducts = computed(() => {
    return currentUser.value?.products.filter((product) => product.name !== 'cfs-portal') ?? [];
  });

  const [permissions, setPermissions] = useState<CfsPermissions | null>(null);

  const fetchCurrentUser = async () => {
    const { data: user } = await AuthenticationService.getUserData(Authentication.accessToken);
    setCurrentUser(user);
  };

  const fetchUserPermissions = async () => {
    const { data: permissions } = await AuthenticationService.getUserPermissions(
      Authentication.accessToken
    );
    setPermissions(permissions.cfs);
  };

  const initializeUser = async () => {
    try {
      await fetchCurrentUser();
      await fetchUserPermissions();
      await useOrganizationStore().fetchWarehouses();
      isAuthenticated.value = true;
    } catch (e) {
      isAuthenticated.value = false;
      throw e;
    }
  };

  const logoutUser = () => {
    Authentication.logout();
    currentUser.value = null;
    isAuthenticated.value = false;
  };
  return {
    currentUserName,

    currentUser,
    permissions,
    isAuthenticated,

    currentUserAvailableProducts,

    logoutUser,
    initializeUser,
    fetchCurrentUser,
    fetchUserPermissions,
  };
});
